<app-moment icon="assessment" title="CGI Score" colour="#e988ec" [momentData]="momentData">
  <div *ngIf="momentData.deleted" class="deleted">
    <div fxLayout="column" fxLayouGap="6px">
      <h4>Deleted</h4>
      <p>{{ momentData.deleted.ts | date: 'fullDate' }}, {{ momentData.deleted.ts | date: 'shortTime' }} by {{ momentData.deleted.author }}</p>
      <p>Reason: {{ momentData.deleted.reason }}</p>
    </div>
  </div>

  <div *ngIf="momentData.edited" class="edited-info">
    <h4>Edited</h4>
    <p>{{ momentData.edited.ts | date: 'fullDate' }}, {{ momentData.edited.ts | date: 'shortTime' }} by {{ momentData.edited.author }}</p>
    <p>Reason: {{ momentData.edited.reason }}</p>
  </div>

  <h4>CGI-SEVERITY: {{ momentData.cgiSeverity }}</h4>
  <h4>CGI-IMPROVEMENT: {{ momentData.cgiImprovement }}</h4>

  <div *ngIf="(featureFlags$ | async)?.isAppointmentMomentsEnabled && !momentData.deleted" fxLayout="row" fxLayoutAlign="center">
    <button *ngIf="momentData.appointmentRef" mat-button (click)="momentService.editAppointmentMoment(momentData)">
      Edit
    </button>
    <button mat-button class="warn" (click)="momentService.softDeleteButtonClicked(momentData)">Delete</button>
  </div>
</app-moment>
